import { render, staticRenderFns } from "./FirstRowServices.vue?vue&type=template&id=2f71026f"
import script from "./FirstRowServices.vue?vue&type=script&lang=js"
export * from "./FirstRowServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports